import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChargePostpayBillMutationVariables = Types.Exact<{
  paymentMethodId: Types.Scalars['Int']['input'];
}>;


export type ChargePostpayBillMutationPage = { readonly __typename?: 'RootMutationType', readonly chargePostpayBill: { readonly __typename?: 'YalperChargeResult', readonly confirmationUrl?: string | null } };


export const ChargePostpayBillDocument = gql`
    mutation ChargePostpayBill($paymentMethodId: Int!) {
  chargePostpayBill(paymentMethodId: $paymentMethodId) {
    confirmationUrl
  }
}
    `;
export type ChargePostpayBillMutationFn = Apollo.MutationFunction<ChargePostpayBillMutationPage, ChargePostpayBillMutationVariables>;

/**
 * __useChargePostpayBillMutation__
 *
 * To run a mutation, you first call `useChargePostpayBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChargePostpayBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chargePostpayBillMutation, { data, loading, error }] = useChargePostpayBillMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useChargePostpayBillMutation(baseOptions?: Apollo.MutationHookOptions<ChargePostpayBillMutationPage, ChargePostpayBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChargePostpayBillMutationPage, ChargePostpayBillMutationVariables>(ChargePostpayBillDocument, options);
      }
export type ChargePostpayBillMutationHookResult = ReturnType<typeof useChargePostpayBillMutation>;
export type ChargePostpayBillMutationResult = Apollo.MutationResult<ChargePostpayBillMutationPage>;
export type ChargePostpayBillMutationOptions = Apollo.BaseMutationOptions<ChargePostpayBillMutationPage, ChargePostpayBillMutationVariables>;